import {texture, padNum} from "p3";
import definitions from "../../definitions";
import Actor from "./Actor";
import settings from "../../settings";

export default class ActorPortcullis extends Actor {
    constructor() {
        super(definitions.ACTOR_ID.PORTCULLIS);

        this.collisionSize = new PIXI.Point(130, 50);
        this.collisionOffsetX = -60;
        this.collisionOffsetY = -80;
        this.collisionType = definitions.COLLISION_TYPE.RECT;
        
        this.interactable = settings.PHASE > 1;
        this.interactionRadius = 150;
    }

    init() {
        super.init();

        this.signals.interact.add(this._open, this);

        let frames = [];
        for (let i = 0; i < 6; ++i) {
            frames[i] = texture("cd_d_cell_portcullis_animation" + padNum(i+1, 2));
        }
        const sequence = new P3.MovieClipSequence(frames, "open");

        this.addViewWithMovieClip(sequence, "open");
    }

    _open() {
        this.collisionEnabled = false;
        this._view.animationSpeed = 10;
        this._view.gotoAndPlay("open", false);
    }

    update() {
        this._fx && this._fx.update(window.dt);

        super.update();
    }

    onViewAdded() {
        super.onViewAdded();

        this._view.anchor.set(0.5, 1);
    }

    onInteractionRangeEnter() {
        super.onInteractionRangeEnter();
    }

    onInteractionRangeExit() {
        super.onInteractionRangeExit();
    }

    onInteractWith(actor) {
        super.onInteractWith(actor);
    }
}